export default __webpack_public_path__ + "static/media/fb.637cd8e1.svg";